import { Directive, inject, Input, OnInit } from '@angular/core';
import { BasePermission } from '@/core/directive/base-permission';
import { PermissionResolverService } from '@/share/services/permission-resolver.service';


@Directive({
    selector: '[appCanAction]',
    standalone: true,
})
export class CanAction extends BasePermission implements OnInit {
    @Input() appCanAction!: string;
    private resolver = inject(PermissionResolverService);

    ngOnInit(): void {
        this.checkPermission(this.resolver.resolve(this.appCanAction));
    }
}
